/**
 * @desc 通过管理域获取分厂信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** isLabour */
  isLabour?: number;
  /** 组织编码 */
  orgCode?: string;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/wap/base/factory',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.QueryBaseInfoListResponse>> {
  return defHttp.get({
    url: '/mock/wap/base/factory',

    params,
  });
}
